
import Link from 'next/link';
import styles from './index.module.scss';
const Story: React.FC = () => {
    return (
        <div className={styles.introductionPack}>
          <Link href={'/rolePage'}>
              <ul>
                  <li>
                    <img src="/img/figure1.png" alt=""/>
                  </li>
                  <li>
                    <img src="/img/figure2.png" alt=""/>
                  </li>
                  <li>
                    <img src="/img/figure5.png" alt=""/>
                  </li>
                  <li>
                    <img src="/img/figure5.png" alt=""/>
                  </li>
                  <li>
                    <img src="/img/figure5.png" alt=""/>
                  </li>
              </ul>
              </Link>
            </div>
    )
}
export default Story;